export const es_operation = {
    title: 'Mercato Libero',
    title_current_operation: 'Operaciones',
    body: 'Se sei già un investitore esperto questa sezione ti aiuterà a determinare velocemente lo street price e il <b>ROI.</b>',
    button: 'Crea e Gestisci',
    title_card: 'Operación',
    overview_label_value: 'Precio',
    overview_label_mq: 'Mc',
    overview_label_deviation: 'SCOSTAMENTO',
    overview_label_roi: 'ROI',
    title_star: 'Contrassegna',
    title_content: 'Contrassegna questa operazione come "In Corso"',
    title_content_starred: 'Operazione in corso.',
    title_content_closed: 'Operazione conclusa.',
    table_starred_start_date: 'Aperta',
    table_starred_closed_date: 'Chiusa',
    table_starred_address: 'Calle',
    table_starred_city: 'Ciudad',
    table_starred_roi: 'ROI',
    table_starred_roe: 'ROE',
    table_starred_profit: 'Profitto',
    title_trash:'Basura',
    table_trash_restore:'Restaurar',
    modal_risorsa:'Nuevo Recurso',
    trash_info:'En esta sección puede restaurar las propiedades eliminadas haciendo clic en el botón Restaurar',
    trash_disclaimer:'Estas propiedades permanecerán en la papelera durante 120 días, luego se eliminarán de forma permanente.',
    popover_myOperation_title: 'Le tue operazioni',
    popover_myOperation_content: '<p>In questa card puoi visionare e gestire l’elenco delle operazioni in corso e concluse per le aste immobiliari. \n' +
        '<br><br>Cliccando sull’icona <i class="fas fa-pencil-alt  abtg__fontIcon"></i> puoi entrare nella scheda dell’operazione e modificare i dati relativi.</p>\n',
    data_importazione: 'fecha de importacion',
    data_cancellazione: 'fecha de cancelación',
    in_corso:'en marcha',
    conclusa:'concluido',
    modifica:'modificación',
    nuovo:'nuevo',

};